import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  fill = "currentColor",
  width = 20,
  height = 20,
  viewBox = "0 0 24 24",
  style = {},
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    style={style}
  >
    <path
      d="M19.7495 2C20.3462 2 20.9185 2.23705 21.3405 2.65901C21.7624 3.08097 21.9995 3.65326 21.9995 4.25V9.712C21.9994 10.5739 21.657 11.4005 21.0475 12.01L12.5475 20.513C11.9374 21.1217 11.1109 21.4636 10.2492 21.4637C9.38742 21.4639 8.56077 21.1224 7.95046 20.514L3.48846 16.06C2.87863 15.4509 2.53572 14.6245 2.53516 13.7626C2.53459 12.9007 2.87643 12.0739 3.48546 11.464L11.9855 2.954C12.2871 2.65184 12.6453 2.41207 13.0396 2.24838C13.4339 2.08469 13.8565 2.00029 14.2835 2H19.7495ZM19.7495 3.5H14.2845C13.8195 3.5 13.3745 3.685 13.0455 4.013L4.53346 12.536C4.21118 12.8656 4.03198 13.3091 4.03479 13.7701C4.0376 14.2311 4.22219 14.6723 4.54846 14.998L9.00946 19.452C9.33839 19.7796 9.78372 19.9636 10.248 19.9636C10.7122 19.9636 11.1575 19.7796 11.4865 19.452L19.9865 10.949C20.3147 10.621 20.4992 10.176 20.4995 9.712V4.25C20.4995 4.05109 20.4204 3.86032 20.2798 3.71967C20.1391 3.57902 19.9484 3.5 19.7495 3.5ZM16.9995 5.502C17.1964 5.502 17.3915 5.5408 17.5735 5.61618C17.7555 5.69156 17.9208 5.80205 18.0601 5.94134C18.1994 6.08063 18.3099 6.24599 18.3853 6.42797C18.4607 6.60996 18.4995 6.80502 18.4995 7.002C18.4995 7.19898 18.4607 7.39404 18.3853 7.57603C18.3099 7.75801 18.1994 7.92337 18.0601 8.06266C17.9208 8.20195 17.7555 8.31244 17.5735 8.38782C17.3915 8.4632 17.1964 8.502 16.9995 8.502C16.6016 8.502 16.2201 8.34396 15.9388 8.06266C15.6575 7.78136 15.4995 7.39982 15.4995 7.002C15.4995 6.60418 15.6575 6.22264 15.9388 5.94134C16.2201 5.66004 16.6016 5.502 16.9995 5.502Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
